module.exports = __webpack_public_path__ + "images/86fdc5b3e962dbf236800301536c1afd-pole position.png";